export const FIELD_FIRST_NAME = 'firstName';
export const FIELD_LAST_NAME = 'lastName';
export const FIELD_EMAIL = 'email';
export const FIELD_PHONE = 'phone';
export const FIELD_GENDER = 'gender';
export const FIELD_NATIONALITY = 'nationality';
export const FIELD_BIRTH = 'birth';
export const FIELD_RADIO = 'radio';
export const FIELD_CHECKBOX = 'checkbox';
export const FIELD_LIST = 'list';
export const FIELD_NUMERIC_LIST = 'numericlist';
export const FIELD_ID_NUMBER = 'idNumber';
export const FIELD_QUANTITY = 'quantity';
export const FIELD_ROLE_ID = 'roleId';
export const FIELD_IBAN = 'iban';
export const FIELD_MULTI_EMAIL = 'multiEmail';
export const FIELD_VAT = 'vat';
export const REQUIRED_TEXT_ERROR = 'errors:formFieldRequired';

export const DATA_TYPE_TEXT = 'text';
export const DATA_TYPE_EMAIL = 'email';
export const DATA_TYPE_LIST = 'list';

export const FIXED_FIELDS = [
  FIELD_FIRST_NAME,
  FIELD_LAST_NAME,
  FIELD_EMAIL,
  FIELD_PHONE,
  FIELD_GENDER,
  FIELD_NATIONALITY,
  FIELD_BIRTH,
  FIELD_RADIO,
  FIELD_CHECKBOX,
  FIELD_ID_NUMBER,
  FIELD_LIST,
  FIELD_NUMERIC_LIST,
  FIELD_MULTI_EMAIL,
  FIELD_VAT,
];
